import http from '../../../axios'

export let certification_apply_index = (params = '', direct = '') =>
  http.post('/certification-apply/index', params, { direct })

export let certification_apply_save = (params = '', direct = '') =>
  http.post('/certification-apply/save', params, { direct })
